document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.getElementById('search-overlay-trigger');
  var panel = document.getElementById('search-overlay-panel');
  var closeBtn = document.getElementById('search-overlay-close');
  var input = document.getElementById('search-overlay-input');

  if (!trigger || !panel) return;

  function openPanel() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    if (input) setTimeout(function () { input.focus(); }, 100);
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    if (panel.classList.contains('is-open')) {
      closePanel();
    } else {
      openPanel();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });

  document.addEventListener('click', function (e) {
    if (panel.classList.contains('is-open') && !panel.contains(e.target) && !trigger.contains(e.target)) {
      closePanel();
    }
  });
});
